import React from 'react'

const SelectBox = ({ containerClassName, label, name, labelClassName = '', children, className = '', onChange = a => a, onBlur = b => b, value = '' }) => {
  return (
    <div className={`${containerClassName || 'my-2'}`}>
      {label && <label htmlFor={name} className={`${labelClassName} block mb-2 text-sm font-bold text-black dark:text-black`}>{label}</label>}
      <select
        name={name}
        className={`${className} max-w-lg border border-gray-100 text-gray-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
      >{children}
      </select>
    </div>
  )
}

export default SelectBox
